import { SPECIES, type ConservationHit, type SpeciesKey } from "@shared/schema";
import { Tooltip } from "../ui/tooltip";

const ORDER: SpeciesKey[] = ["human", "mouse", "rat", "zebrafish", "drosophila"];

/**
 * Inline conservation visualiser — 5 dots, one per species in ORDER. A
 * filled-green dot = direct orthologue/partner evidence, a faded-green dot
 * = inferred-from-orthologue, and an empty grey dot = nothing yet.
 */
export function ConservationDots({ hits }: { hits: ConservationHit[] }) {
  const byKey = new Map(hits.map((h) => [h.species, h.evidence]));
  return (
    <Tooltip
      content={
        <ul className="space-y-0.5 text-[11px]">
          {ORDER.map((k) => {
            const ev = byKey.get(k) ?? "none";
            return (
              <li key={k} className="flex items-center justify-between gap-3">
                <span>{SPECIES[k].common}</span>
                <span className="text-muted-foreground">
                  {ev === "direct" ? "Direct" : ev === "inferred" ? "Inferred" : "—"}
                </span>
              </li>
            );
          })}
        </ul>
      }
    >
      <span className="conservation-dots" aria-label="Cross-species conservation">
        {ORDER.map((k) => {
          const ev = byKey.get(k) ?? "none";
          return <span key={k} data-evidence={ev} />;
        })}
      </span>
    </Tooltip>
  );
}
